import { clsx } from 'clsx';
import styles from './Segmented.module.css';

type Option<T> = { value: T; label: string };

type Props<T extends string | number | boolean> = {
  options: Option<T>[];
  value: T;
  onChange: (v: T) => void;
  className?: string;
};

export function Segmented<T extends string | number | boolean>({
  options,
  value,
  onChange,
  className,
}: Props<T>) {
  return (
    <div className={clsx(styles.root, className)} role="group">
      {options.map((opt) => (
        <button
          key={String(opt.value)}
          type="button"
          className={clsx(styles.item, opt.value === value && styles.active)}
          onClick={() => onChange(opt.value)}
          aria-pressed={opt.value === value}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
